import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/posthog';

export const usePageTracking = () => {
  const location = useLocation();
  const previousPath = useRef<string>('');

  useEffect(() => {
    const currentPath = location.pathname + location.search;
    const pageTitle = document.title;
    const referrer = previousPath.current || document.referrer;

    // Track the page view
    trackPageView(currentPath, pageTitle, referrer);

    // Update previous path for next navigation
    previousPath.current = currentPath;
  }, [location]);
};
